// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"cff04717","295":"5953888b","505":"a9214608","513":"5aee186a","569":"151afd92","667":"3c328756","672":"09814971","703":"66773fa9","836":"7c7d116e","901":"eb535c16"}[chunkId] + ".chunk.js";
};